import { ROUTES } from "../App";
import { useEffect, useRef, useState } from "react";
import useMoveTo from "../constants/navigation";
import { IMAGES } from "../constants/images";

const Splash = () => {
  const navigate = useMoveTo();
  const askedRef = useRef(false);
  // const [isVideoReady, setIsVideoReady] = useState(false);

  // Fire AFTER image is loaded now
  useEffect(() => {
    if (askedRef.current) return;
    askedRef.current = true;

    // const password = prompt("Enter password:");

    // if (password !== "enter#2") {
    //   alert("Incorrect password");
    //   window.location.reload();
    //   return;
    // }

    const isNotFirstTime = localStorage.getItem("isNotFirstTime");

    setTimeout(() => {
      if (!isNotFirstTime) {
        navigate(ROUTES.ONBOARDING, { replace: true });
      } else {
        navigate(ROUTES.SIGN_IN, { replace: true });
      }
    }, 2000);
  }, [navigate]);

  return (
    <div className="bg-[#337893] h-screen w-screen overflow-hidden">
      {/* <video
    className="absolute top-0 left-0 w-full h-full object-cover"
    autoPlay
    loop
    muted
    playsInline
    onLoadedData={() => {
      console.log("Video loaded");
      setIsVideoReady(true);
    }}
  >
    <source
      src={require("../assets/videos/splash_video.mov")}
      type='video/mp4; codecs="hvc1"'
    />
    <source
      src={require("../assets/videos/splash_video.webm")}
      type="video/webm"
    />
  </video> */}

      {/* IMAGE INSTEAD OF VIDEO */}
      {/* <img
    src={IMAGES.zylenIntro}
    alt="Splash"
    className="absolute top-0 left-0 w-full h-full object-cover"
    onLoad={() => {
      console.log("Image loaded");
      setIsVideoReady(true);
    }}
  /> */}

      {/* INLINE SVG INSTEAD OF IMAGE */}
      <div
        className="absolute top-0 left-0 w-full h-full flex items-center justify-center"
        onLoad={() => {
          console.log("SVG loaded");
          // setIsVideoReady(true);
        }}
      >
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 473 800"
          height="110%"
          preserveAspectRatio="xMidYMid slice"
        >
          <style>
            {`.a{fill:#337893}.b{fill:#fff}`}
          </style>
          <path fillRule="evenodd" className="a" d="m483.7-10v830.9h-493.7v-830.9z" />
          <path className="b" d="m180.1 698l11-10c0.6-0.6 0.2-1.7-0.6-1.7h-8.9c-1.4 0-2.6-1.3-2.5-2.8 0.1-1.3 1.2-2.4 2.5-2.4h16.9c1.6 0 3 1.4 3 3.2 0 0.9-0.4 1.8-1 2.4l-11.3 10.3c-0.7 0.5-0.3 1.7 0.6 1.7h9.3c1.4 0 2.5 1.1 2.5 2.5 0 1.5-1.1 2.6-2.5 2.6h-16.9c-1.8 0-3.2-1.5-3.2-3.3 0-0.9 0.4-1.9 1.1-2.5z" />
          <path className="b" d="m210.2 690.8c0 5.7 1.5 7.9 5.4 7.9 3.5 0 5.6-1.8 5.6-8.5v-3.1c0-0.9 0-1.9 0-2.9 0.1-1.9 1.3-3.4 2.9-3.4 1.7 0 3 1.6 2.9 3.7 0 1.2 0 2.5 0 3.5v12.1c0 10.1-3.4 14.8-12.3 14.8-2.9 0-5.4-0.5-7.6-1.8-1.3-0.7-1.7-2.7-1-4.2 0.7-1.3 2-1.7 3.2-1 1.4 1 3.2 1.7 5.2 1.7 4.6 0 6.7-2.6 6.7-8.6v-1.1c-1.3 2.5-3.6 4-7.4 4-6.8 0-9.4-3.9-9.4-12.6v-6.9c0-2 1.3-3.6 2.9-3.6 1.6 0 2.9 1.6 2.9 3.6 0 0 0 6.4 0 6.4z" />
          <path className="b" d="m254.9 699.8c2.7 0 4.7-0.7 6.1-2.2 0.8-0.8 2-0.9 2.9-0.2 1.3 1 1.4 3.2 0.1 4.3-2.7 2.1-6.2 2.7-10 2.7-8.3 0-12.1-4.7-12.1-11.8 0-7 3.9-11.7 12.7-11.7 7 0 10.8 2.9 11.6 10.1 0.2 1.7-1 3.2-2.5 3.2h-14.4c-0.5 0-0.9 0.6-0.8 1.2 0.8 3.1 3 4.4 6.4 4.4zm-5.4-9.4h9.9c0.5 0 0.9-0.6 0.8-1.1-0.6-2.9-2.6-4-5.3-4-3.1 0-5.2 1.1-6.2 3.8-0.2 0.6 0.2 1.3 0.8 1.3z" />
          <path className="b" d="m231.4 700.9v-26.3c0-2 1.4-3.6 3.1-3.6 1.7 0 3.1 1.6 3.1 3.6v26.3c0 2-1.4 3.6-3.1 3.6-1.7 0-3.1-1.6-3.1-3.6z" />
          <path className="b" d="m292.2 692.5v8.8c0 1.8-1.2 3.2-2.7 3.2-1.5 0-2.8-1.4-2.8-3.2v-9.2c0-3.6-2.3-6-5.8-6-3.5 0-5.7 2.5-5.7 6v9.2c0 1.8-1.2 3.2-2.7 3.2-0.8 0-1.5-0.3-2-0.9-0.5-0.6-0.8-1.4-0.8-2.3v-8.8c0-7.1 4.5-11.7 11.4-11.7 6.9 0 11.1 4.7 11.1 11.7z" />
          <path className="b" d="m269.1 282.1c1.8 17.1-11.5 17.7-23.2 21.8-6.4 2.2-22.8 10.8-24.7 17.4-0.9 3-0.2 6.7 2.7 8.5 7.5 4.3 48.9-21.9 58.5-10.6 5 6 6.2 21.4-3.2 23-10.3 1.8-45.4-17.4-58-5.7-4.1 3.7-7.7 7.2-13.7 8-14.7 2-21.1-16-10.4-25.1 4-3.4 7.7-3.7 12.1-5.6 10.1-4.4 17.4-10.4 21.6-20.8 3.4-8.1 2.4-16.6 9.6-22.8 10.8-9.3 27.3-2 28.7 11.9z" />
          <path className="b" d="m224 280.6c0 6.9-16.3 14.6-24.4 14.6-8.1 0-14.6-6.5-14.6-14.6 0-8.1 6.5-14.6 14.6-14.6 8.1 0 24.4 7.8 24.4 14.6z" />
        </svg>
      </div>
    </div>

  );
};

export default Splash;

